exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-4d099d21]{font-size:11px;color:red}.disclaimer[data-v-4d099d21]{font-family:PT Sans Narrow,sans-serif;font-size:13px;color:#6f8695}.error-message[data-v-4d099d21]{color:red}.cms-radio-group .cms-radio-button[data-v-4d099d21],.cms-radio-group[data-v-4d099d21]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.cms-radio-group .cms-radio-button label[data-v-4d099d21]{margin:0;padding:0;margin-left:8px;font-size:16px;text-transform:none;color:#797979}.cms-radio-group .cms-radio-button+.cms-radio-button[data-v-4d099d21]{margin-left:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d099d21","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/AddResident.vue
// module id = OfYX
// module chunks = 0 1